import {notNull} from '../../../../../../library/clxProductNet/assets/js/modules/common/assert';

export default class UiCalculator {
    private mobileStickyHeader: HTMLDivElement | null;

    private readonly notificationBarWrapperTop: HTMLDivElement | null;

    private contentPartElement: HTMLDivElement;

    private readonly pageContent: HTMLDivElement | null;

    private readonly anchorNavi: HTMLDivElement | null;

    private cartContainer: HTMLDivElement | null;

    private readonly cartSidebarWidgetContainer: HTMLDivElement | null;

    constructor() {
        this.mobileStickyHeader = document.querySelector('body.mobile .sticky-logo');
        this.notificationBarWrapperTop = document.querySelector('#notification_bar_top_container');
        this.contentPartElement = notNull(document.querySelector('#main section#content_part')) as HTMLDivElement;
        this.pageContent = this.contentPartElement.querySelector('div.page-content');

        this.anchorNavi = document.querySelector('#main section#content_part .shoppingcart-detail .anchor-navigation');
        this.cartContainer = document.querySelector('#main section#content_part .shoppingcart-detail');
        this.cartSidebarWidgetContainer = document.querySelector('#main section#content_part .shoppingcart-detail .sidebar .widget-container');

        if (document.body.classList.contains('mobile')) {
            this._initMobileHeaderNotificationBar();
        } else {
            this._initDesktopHeaderNotificationBar();
        }
    }

    private _initDesktopHeaderNotificationBar(): void {
        this._calculateDesktopOffsets();
        window.addEventListener('resize', () => {
            this._calculateDesktopOffsets();
        });

        document.addEventListener('scroll', () => {
            this._calculateDesktopOffsets();
        });

        const navigationCloseButtons = document.querySelectorAll('.mod_notification_bar .close-overlay');

        navigationCloseButtons.forEach((navigationCloseButton) => {
            if (navigationCloseButton !== null) {
                navigationCloseButton.addEventListener('click', () => {
                    this._calculateDesktopOffsets();
                });
            }
        });
    }

    private _initMobileHeaderNotificationBar(): void {
        this._calculateMobileOffsets();

        document.addEventListener('scroll', () => {
            this._calculateMobileOffsets();
        });

        const navigationCloseButtons = document.querySelectorAll('.mod_notification_bar .close-overlay');

        navigationCloseButtons.forEach((navigationCloseButton) => {
            if (navigationCloseButton !== null) {
                navigationCloseButton.addEventListener('click', () => {
                    this._calculateMobileOffsets();
                });
            }
        });
    }

    private _calculateDesktopOffsets(): void {
        if (this.notificationBarWrapperTop) {
            let naviOffset: number = this.notificationBarWrapperTop.offsetHeight;
            this.contentPartElement.style.marginTop = naviOffset.toString() + 'px';

            if (this.anchorNavi) {
                this.anchorNavi.style.marginTop = naviOffset.toString() + 'px';
            }

            // '170' is the sticky-offset for the container (see shoppingcart-detail.less) and must be changed here if it is changed in the less file
            if (this.cartSidebarWidgetContainer) {
                this.cartSidebarWidgetContainer.style.top = (naviOffset + 170).toString() + 'px';
            }
        }

        if (this.pageContent) {
            let cartEmpty: boolean = this.cartContainer?.classList.contains('cart-empty') ?? false;
            if (cartEmpty) {
                this.pageContent.style.paddingTop = '0';
            } else {
                this.pageContent.removeAttribute('style');
            }
        }
    }

    private _calculateMobileOffsets(): void {
        let headerOffset: number = this.mobileStickyHeader?.offsetHeight ?? 0;
        let naviOffset: number = this.notificationBarWrapperTop?.offsetHeight ?? 0;
        let anchorNaviHeight: number = this.anchorNavi?.offsetHeight ?? 0;

        if (this.notificationBarWrapperTop) {
            if (this.anchorNavi) {
                this.anchorNavi.style.marginTop = naviOffset.toString() + 'px';
                this.contentPartElement.style.marginTop = (headerOffset + anchorNaviHeight).toString() + 'px';
            } else {
                this.contentPartElement.style.marginTop = headerOffset.toString() + 'px';
            }
        }
    }
}
